import ubbj_api from "@/services/axios";

export const getCall = async (_id) => {
  return ubbj_api
    .post("listar/convocatorias", { id_tipoconv: _id })
    .then((response) => {
      return response.data.Convocatorias;
    });
};
